var _defs, _title;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "300 400 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1299.903,
    height: 1023.307
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.199597, 0, 0, 1.194952, -892.655212, 18.976774)",
    style: {
      clipPath: "url(#clip-2)"
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "C")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    className: "cls-7",
    cx: 1075.488,
    cy: 400.693,
    r: 70.317,
    style: {
      fill: "rgb(255, 229, 95)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    className: "cls-8",
    x2: 1115.272,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px"
    },
    x1: 1035.336,
    y1: 405.849,
    y2: 405.849
  }), /*#__PURE__*/React.createElement("text", {
    id: "C",
    className: "cls-13",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: "54.585px",
      fontWeight: 700,
      letterSpacing: "0.54585px",
      lineHeight: "87.336px",
      perspectiveOrigin: "24.7656px 34px"
    },
    x: 0,
    y: 338.631
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1090,
    y: 394.631,
    style: {
      fontSize: "54.6px",
      wordSpacing: 0,
      letterSpacing: "0.55px"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "_53-71",
    "data-name": "53-71",
    className: "cls-14",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 48,
      perspectiveOrigin: "38.8125px 18.5px"
    },
    x: 0,
    y: 404.822
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1110,
    y: 435.822,
    style: {
      fontSize: 30,
      wordSpacing: 0
    }
  }, "53-71"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.1ee2f73ccdaf01090966d5a336495a75.svg";
export { ForwardRef as ReactComponent };